import { render, staticRenderFns } from "./AssetsContainer.vue?vue&type=template&id=ffefa1be&"
import script from "./AssetsContainer.vue?vue&type=script&lang=js&"
export * from "./AssetsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports